import * as React from 'react';
import { History } from 'history';
import Model from './event-model';
import BasePicklistCard from '../base/base-picklistcard.component';

interface IProps {
  history: History;
  caption?: string;
  currentId?: number;
  astemplate?: string;
  personalinfoType?: string;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any, page?: any) => void;
  disableSearch?: boolean;
  disableBackButton?: boolean;
  disableCard?: boolean;
}

interface IState {
}

export default class EventPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onLoad = (data: any) => {
    this.props.onLoad?.(data)
  }

  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilterList2(this.props.personalinfoType)} model={Model} currentId={this.props.currentId} onLoad={this.onLoad} onLoadAll={this.props.onLoadAll} searchField={this.props.disableSearch? ' ' : ''} cardCount={4} swipe='horizontal' disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
